'use client';

import { useContext, useMemo } from 'react';
import ThemeContext from '@src/contexts/theme';

function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a app');
  }

  return useMemo(
    () => ({
      ...context,
    }),
    [context]
  );
}

export default useTheme;
